module.exports = __webpack_public_path__ + "static/media/pokeball.9d48ad1b.png";